import api from '../api';

export const fetchNotifications = (data) => api.post('/core/functions/fetchNotifications', data);

export const markNotificationsRead = (data) => api.post('/core/functions/markNotificationsRead', data);
